import BaseModal from "components/BaseModal";
import { MODAL_SIZE_SMALL } from "constants/Layout";
import React, { forwardRef, useRef } from "react";
import DocumentsSection from "./DocumentsSection";
import { Upload } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";
import { removeNonPrintableUnicodeCharacters } from "utils/fileUtils";
import ExceptionAPI from "restAPI/ExceptionAPI";
import axios from "axios";
import message from "components/CustomMessage";
import Vocabulary from "components/Vocabulary";

const DocumentUploadPopup = forwardRef(function DocumentUploadPopup(
  props,
  ref
) {
  const docListRef = useRef();

  const onFileChange = async (e) => {
    const file = e.file;
    if (file) {
      const dismissUploadingMessage = message.loading("Uploading");
      const { signedUploadUrl } = await ExceptionAPI.getDocumentSignedUrl(
        props.id,
        {
          fileName: removeNonPrintableUnicodeCharacters(file.name),
        }
      ).promise;
      try {
        await axios({ method: "put", url: signedUploadUrl, data: file });
        message.success("Successfully uploaded document");
        docListRef.current.refresh();
      } catch (e) {
        console.log("upload error", e);
      } finally {
        dismissUploadingMessage();
      }
    }
  };
  const uploadProps = {
    multiple: false,
    beforeUpload: () => false,
    onChange: (e) => onFileChange(e),
  };
  return (
    <BaseModal
      modalProps={{
        width: MODAL_SIZE_SMALL,
        footer: null,
        title: <>Add document to <Vocabulary name= "exception"/></>,
      }}
      ref={ref}
      afterClose={props.afterClose}
    >
      <DocumentsSection id={props.id} ref={docListRef} />
      <Upload.Dragger {...uploadProps} className="m-t-l" fileList={[]}>
        <div className="d-flex justify-content-center">
          <CloudUploadOutlined className="ant-upload-drag-icon p-r-xs" style={{paddingTop: "6px"}}/>
          <p className="ant-upload-text">
            Drop your files or click to <br />
            upload from here
          </p>
        </div>
      </Upload.Dragger>
    </BaseModal>
  );
});

export default DocumentUploadPopup;
